import { Link } from 'react-router';
import { InfoPage, InfoSection } from './InfoPage';

import { CONTACT_EMAIL } from '../lib/contact';

export function ContactScreen() {
  return (
    <InfoPage
      title="Contact"
      standfirst="Most things are quicker to sort out inside the app. For everything else, here is what reaches a person."
    >
      <InfoSection heading="About a ride you have booked">
        <p className="m-0">
          Message the driver from the ride itself. It is the fastest route by a long way — they can
          answer about the pickup point, the timing or the boot space, and none of it needs us.
        </p>
        <p className="m-0">
          Your conversations are under <Link to="/messages">Messages</Link>.
        </p>
      </InfoSection>

      <InfoSection heading="Reporting a member or a ride">
        {CONTACT_EMAIL ? (
          <p className="m-0">
            Write to <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a> with the name of the
            member and the date of the ride. Anything that put somebody in danger should say so in
            the subject line.
          </p>
        ) : (
          <>
            <p className="m-0">
              <strong>There is currently no way to report anybody to us.</strong> No address, no
              form, nothing that reaches a person. That is a gap in the product, and saying so is
              the only honest thing to put here.
            </p>
            <p className="m-0">
              A review is not a substitute and we will not offer it as one: reviews can only be
              written after a ride has actually happened, so they are no use for a ride that was
              cancelled, for anything that occurred before departure, or to anybody who was not in
              the car.
            </p>
          </>
        )}
        <p className="m-0">
          If somebody is in immediate danger, ring 111. OpenRoad cannot help in the moment, and
          waiting for a reply would cost time.
        </p>
      </InfoSection>

      <InfoSection heading="Anything else">
        {CONTACT_EMAIL ? (
          <p className="m-0">
            The same address — <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>. Questions
            about an account, a payment, or the platform itself all land there.
          </p>
        ) : (
          <p className="m-0">
            This deployment has no contact address configured. That is a gap rather than a policy,
            and it is on the list.
          </p>
        )}
      </InfoSection>
    </InfoPage>
  );
}
